import { HeTimesheetDetail } from "@/features"

const HeTimesheetDetailPage = () => {
  return <HeTimesheetDetail />
}

export default HeTimesheetDetailPage